import styled from 'styled-components';
export const Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-1aspl3w" }) `margin:10px 0;&:empty{display:none;}`;
//# sourceMappingURL=styles.js.map